import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, SendOnboardingEmailDialogueHandler } from './types';
import SendOnboardingEmailContext from './AccountPanelContext';

const { ConfirmationDialogue } = vp;

type SendOnboardingEmailDialogueProps = {
  handleDialogue: DialogueHandler<SendOnboardingEmailDialogueHandler>;
};

type FC = FunctionComponent<SendOnboardingEmailDialogueProps>;

const SendOnboardingEmailDialogue: FC = ({ handleDialogue }: SendOnboardingEmailDialogueProps) => {
  const {
    showSendOnboardingEmailConfirmAlert,
    showSendOnboardingEmailSuccessAlert,
    showSendOnboardingEmailErrorAlert,
    sendOnboardingEmailError,
  } = useContext(SendOnboardingEmailContext);

  return useMemo(
    () => (
      <div>
        {/* Send Onboarding Email Confirmation */}
        <ConfirmationDialogue
          isVisible={showSendOnboardingEmailConfirmAlert}
          title="Are you sure you wish to send onboarding email?"
          subTitle=""
          status="alert"
          confirm={{
            label: 'Yes',
            action: () => handleDialogue({ type: 'confirm', state: 'success' }),
          }}
          cancel={{
            label: 'No',
            action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />

        {/* Send Onboarding Email Success */}
        <ConfirmationDialogue
          isVisible={showSendOnboardingEmailSuccessAlert}
          title="Success! The Onboarding Email was successfully sent."
          status="success"
          subTitle=""
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'send', state: 'success' }),
          }}
        />
        {/* Send Onboarding Email Fail */}
        <ConfirmationDialogue
          isVisible={showSendOnboardingEmailErrorAlert}
          title="Error! The Onboarding Email was not sent."
          status="error"
          subTitle={sendOnboardingEmailError}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'send', state: 'fail' }),
          }}
        />
      </div>
    ),
    [
      showSendOnboardingEmailConfirmAlert,
      showSendOnboardingEmailSuccessAlert,
      showSendOnboardingEmailErrorAlert,
      sendOnboardingEmailError,
    ],
  );
};

export default SendOnboardingEmailDialogue;
